"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageComposerLocalReducer = exports.initialStateEntry = void 0;
exports.initialStateEntry = {
    detectedLink: undefined,
    images: [],
    linkPreview: undefined,
    selection: { end: 0, start: 0 },
    text: '',
};
const messageComposerLocalReducer = (state, action) => {
    var _a;
    if (!action.currentConversationId)
        return state;
    const currentConversationState = (_a = state[action.currentConversationId]) !== null && _a !== void 0 ? _a : exports.initialStateEntry;
    switch (action.type) {
        case 'setText': {
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: Object.assign(Object.assign({}, currentConversationState), { text: action.text }) });
        }
        case 'setImages': {
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: Object.assign(Object.assign({}, currentConversationState), { images: action.images }) });
        }
        case 'setDetectedLink': {
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: Object.assign(Object.assign({}, currentConversationState), { detectedLink: action.detectedLink }) });
        }
        case 'setLinkPreview': {
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: Object.assign(Object.assign({}, currentConversationState), { linkPreview: action.linkPreview }) });
        }
        case 'setSelection': {
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: Object.assign(Object.assign({}, currentConversationState), { selection: action.selection }) });
        }
        case 'reset':
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: exports.initialStateEntry });
        case 'addEmoji': {
            const pre = currentConversationState.text.substr(0, currentConversationState.selection.start);
            const post = currentConversationState.text.substr(currentConversationState.selection.end);
            const text = pre + action.emoji + post;
            return Object.assign(Object.assign({}, state), { [action.currentConversationId]: Object.assign(Object.assign({}, currentConversationState), { selection: {
                        end: currentConversationState.selection.start + action.emoji.length,
                        start: currentConversationState.selection.start + action.emoji.length,
                    }, text }) });
        }
        default:
            return state;
    }
};
exports.messageComposerLocalReducer = messageComposerLocalReducer;
